<template>
  <div class="team-page">
    <div class="big-title">
      <span>TEAM</span>
    </div>
    <div class="team-introduce">
      Whales Entertainment, based in Los Angeles, is a passionate game developer and publisher co-founded by game enthusiasts Hanshi 'Hans' Li and Yue 'Luna' Ming. With over a decade of dedicated board game experience and an established Chinese speaking YouTube channel, "Worthy OPawnent", Hans and Luna serve as a significant bridge between the Chinese and international board game communities.
      Their pivotal moment came in 2022, when Hans became the first champion of the World Series of Board Gaming (WSBG). Inspired by this triumph, they founded Whales Entertainment to continue their mission of advocating for Chinese board gamers, providing a platform for Chinese designers to refine their creations, and introducing them to the global market.
      Their debut release, "Come on Bite me!" – a family-friendly party game crafted by Chinese designer Weifeng Feng – was well loved by the community. Currently, we are developing a tactical skirmish tabletop game called "Win or Die," which is expected to be launched on Gamefound and released by the end of 2024. With every roll of the dice, Whales Entertainment is committed to change the stereotypes of “Made in China” to “Create in China”.
    </div>
    <ul class="team-member">
      <li>
        <img src="@/assets/images/mobile/hans.png" class="avatar" alt="">
        <div class="name">Hans</div>
      </li>
      <li>
        <img src="@/assets/images/mobile/luna.png" class="avatar" alt="">
        <div class="name">Luna</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="less">
.team-page {
  background: url("@/assets/images/mobile/team_bg.png") no-repeat;
  background-size: 100% 100%;
  font-family: "Aleo Regular";
  padding-bottom: .8rem;
  .big-title {
    color: #000;
    span {
      padding: 0 .8rem;
      font-size: .7rem;
      position: relative;
      line-height: 1.8rem;
      height: 1.8rem;
      display: inline-block;
      font-family: "Aleo Regular";
      &::after{
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: .2rem;
        background: #30affd;
        border-radius: 0.04rem;
      }
    }

  }
  .team-introduce {
    font-size: .6rem;
    color: #505050;
    padding: 0 .5rem;
    margin: 50px auto 30px;
    line-height: .9rem;
    text-align: left;
  }
  .team-member {
    font-size: .7rem;
    color: #444;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: .6rem;
    > li {
      display: flex;
      flex-direction: column;
      align-items: center;
      &:first-child {
        margin-right: 3rem;
      }
      .avatar {
        width: 4rem;
        margin-bottom: .4rem;
      }
    }
  }
}
</style>
